



















































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import ApiKeyModule from '@/store/modules/ApiKey';
import AuthModule from '@/store/modules/Auth';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import GeneralModule from '@/store/modules/General';

@Component({
  components: {
    Table,
  },
})
export default class SeamlessKey extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Partner',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Agent',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Secret',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'URL',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Edit',
      },
    ],
  ];

  ApiKeyInstance = getModule(ApiKeyModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  searchText = '';

  editModel = {
    url: '',
    _id: '',
    partner: '',
    agent: '',
  };

  data = [];

  created() {
    this.fetchKey();
  }

  async fetchKey() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.ApiKeyInstance.FetchSeamlessKey();
    if (res.code) {
      this.checkError(res);
    }
    this.GeneralInstance.toggleLoading(false);
    this.data = this.ApiKeyInstance.listSeamlessKey;
  }

  handleSearch() {
    this.data = this.ApiKeyInstance.listSeamlessKey
      .filter((item) => item.agent && item.agent.includes(this.searchText.toLowerCase()));
  }

  handleEdit(item) {
    const {
      _id, url, partner, agent,
    } = item;
    this.editModel._id = _id;
    this.editModel.url = url;
    this.editModel.partner = partner;
    this.editModel.agent = agent;
  }

  handleCancel() {
    this.editModel = {
      url: '',
      _id: '',
      partner: '',
      agent: '',
    };
  }

  async handleSave() {
    if (this.editModel.url.slice(-1) !== '/') {
      this.editModel.url = `${this.editModel.url}/`;
    }
    const res = await this.ApiKeyInstance.UpdateSeamlessKey(this.editModel);
    this.checkError(res);
    await this.fetchKey();
    this.handleCancel();
  }
}
